// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--CaNgt";
export var navContainer = "footer-module--navContainer--L0N+N";
export var info = "footer-module--info--ejuJH";
export var nav = "footer-module--nav--7v9wR";
export var copyright = "footer-module--copyright--kJamD";